import React, {useState} from "react";
import Typography from "@material-ui/core/Typography";
import axios from "../../security/axios";
import "./ContactUpdate.css";
import NotificationBar from "../../components/notification-bar/NotificationBar";

const STEP_NAMES = {input: 'Input', database: 'Database', learnworlds: 'LearnWorlds', iterable: 'Iterable'};

const describeSteps = (steps) => (steps || [])
    .map(s => `${STEP_NAMES[s.step] || s.step}: ${s.ok ? 'OK' : 'FAILED'} (${s.detail})`)
    .join(' | ');

const ContactUpdate = () => {
    const [updating, setUpdating] = useState(false);
    const [oldEmail, setOldEmail] = useState("");
    const [newEmail, setNewEmail] = useState("");
    const [notification, setNotification] = useState({
        message: '',
        severity: '',
    });

    const performContactUpdate = async (event) => {
        event.preventDefault();
        setUpdating(true);
        try {
            const result = await axios.post(`/email-update`, {
                oldEmail,
                newEmail,
            });
            // The shared axios interceptor resolves (instead of rejecting) non-401 errors with the error object.
            const response = (result && result.response) || result;
            const data = (response && response.data) || {};

            if (response && response.status === 200 && data.success) {
                const msg = {message: `Email switching finished successfully. ${describeSteps(data.steps)}`, severity: 'success'};
                setNotification(msg);
                setUpdating(false);
                return;
            }
            const msg = data.steps
                ? {message: `Email switching did not fully finish. ${describeSteps(data.steps)}`, severity: 'error'}
                : {message: 'Error occurred during switching emails.', severity: 'error'};
            setNotification(msg);
            setUpdating(false);
        } catch (e) {
            const msg = {message: 'Error occurred during switching emails.', severity: 'error'};
            setNotification(msg);
            setUpdating(false);
        }

    };

    return (
        <section>
            <div className="ml-1">
                <Typography variant="h5" className="ml-1">
                    Contact update - switch email addresses
                </Typography>
            </div>
            {(notification.message) && (
                <NotificationBar notification={ notification }
                                 closeCallback={() => setNotification({
                                     message: null,
                                     severity: null,
                                 })}/>
            )}
            <div className="ml-1 mr-1 mt-50">
                <form onSubmit={ performContactUpdate }>
                    <div className="mt-25">
                        <Typography variant="body1" gutterBottom>
                            What is the email you want to update?
                        </Typography>
                        <div>
                            <div className="mt-10 mb-50">
                                <input className="w-100 contact-update-input"
                                       required
                                       type="email"
                                       value={oldEmail}
                                       onChange={e => setOldEmail(e.target.value)}/>
                            </div>
                        </div>
                    </div>
                    <div className="mt-25">
                        <Typography variant="body1" gutterBottom>
                            What is the email you would like this email to change to?
                        </Typography>
                        <div>
                            <div className="mt-10 mb-50">
                                <input className="w-100 contact-update-input"
                                       required
                                       type="email"
                                       value={newEmail}
                                       onChange={e => setNewEmail(e.target.value)}/>
                            </div>
                        </div>
                    </div>
                    <div className="mt-75 mb-10">
                        <div>
                            <button type="submit" className="button save-btn accent" disabled={updating}>
                                Perform Update
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </section>
    );
};

export default ContactUpdate;